import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import ReactPaginate from 'react-paginate'
import { Translation } from 'react-i18next'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel
} from '@material-ui/core/'
import FilterFields from './FilterFields'
import DropDownPagination from './dropDownPagination'
import store from '../store'
import { changeRowsPerPage } from '../actions'
function SortableTable(props) {
  const {
    data,
    createRowComponent,
    headerCells,
    defaultOrderBy,
    defaultOrder,
    enableFilters,
    dense,
    classes,
    assignmentPageSize = 10,
    isSearchAssignmentSuccess = false,
    tablePlace
  } = props

  const [order, setOrder] = React.useState(defaultOrder)
  const [orderBy, setOrderBy] = React.useState(defaultOrderBy)
  const [page, setPage] = React.useState(0)
  const [customComparator, setCustomComparator] = React.useState(null)
  const [filters, setFilters] = React.useState({})

  const rowsToShow = store.getState().pagination.rowsPerPage

  const handleRequestSort = (event, property, _customComparator) => {
    const isAsc = orderBy === property && order === 'asc'
    const isDesc = orderBy === property && order === 'desc'
    setOrder(isAsc ? 'desc' : 'asc')
    setOrderBy(isDesc ? null : property)

    if (_customComparator) setCustomComparator(() => _customComparator)
    else if (customComparator !== null) setCustomComparator(null)
  }

  const handleChangePage = (event) => {
    setPage(event.selected)
  }

  const handleChangeFilterValue = (_filters) => {
    setFilters(_filters)
    setPage(0)
  }

  const filteredData =
    enableFilters && Object.keys(filters).length > 0
      ? filterData(data, headerCells, filters)
      : data

  const _rowsPerPage =
    Math.floor(rowsToShow) !== rowsToShow ||
    rowsToShow <= 0 ||
    isNaN(rowsToShow)
      ? 10
      : rowsToShow

  const _pageCount = !data
    ? null
    : Math.ceil(filteredData.length / _rowsPerPage)

  //pagination rows dropdown
  const [paginationRowValue, setPaginationRowValue] = React.useState(10)
  const changePagination = (e) => {
    setPaginationRowValue(e.target.value)
    store.dispatch(changeRowsPerPage(e.target.value))
    setPage(0)
  }

  React.useEffect(() => {
    if (isSearchAssignmentSuccess) {
      setPaginationRowValue(assignmentPageSize)
      store.dispatch(changeRowsPerPage(assignmentPageSize))
      setPage(0)
    }
  }, [isSearchAssignmentSuccess, assignmentPageSize])

  const pathname = store.getState().router.location.pathname
  let summaryArray = {}
  if (pathname === '/dashboard/salary') {
    summaryArray = filteredData.reduce(
      (acc, item) => {
        acc.gross_salary += item.gross_salary
        acc.sumWithTax += item.sumWithTax
        acc.take_home_pay += item.take_home_pay
        acc.expenses_cost += item.expenses_cost
        acc.reimbursment_cost += item.reimbursment_cost
        return acc
      },
      {
        gross_salary: 0,
        sumWithTax: 0,
        take_home_pay: 0,
        expenses_cost: 0,
        reimbursment_cost: 0
      }
    )
  }

  return (
    <Translation>
      {(t) => (
        <div className={classes.root}>
          {enableFilters ? (
            <>
              <div className={classes.filters}>
                <div>
                  <FilterFields
                    headerCells={headerCells.filter((el) => el.filter)}
                    handleChangeFilterValue={handleChangeFilterValue}
                    data={data}
                  />
                </div>
                <div style={{ marginTop: 'auto' }}>
                  <DropDownPagination
                    paginationRowValue={paginationRowValue}
                    changePagination={changePagination}
                  />
                </div>
              </div>
            </>
          ) : null}
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            aria-label="enhanced table"
          >
            <SortableTableHead
              classes={classes}
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              headerCells={headerCells}
              dense={dense}
            />
            <TableBody>
              {!filteredData || filteredData.length === 0
                ? null
                : !orderBy
                ? filteredData
                    .slice(
                      page * _rowsPerPage,
                      page * _rowsPerPage + _rowsPerPage
                    )
                    .map((row, index) => createRowComponent(row, index))
                : stableSort(
                    filteredData,
                    getComparator(order, orderBy, customComparator)
                  )
                    .slice(
                      page * _rowsPerPage,
                      page * _rowsPerPage + _rowsPerPage
                    )
                    .map((row, index) => createRowComponent(row, index))}
              {pathname === '/dashboard/salary' ? (
                <>
                  <TableRow>
                    <TableCell
                      component="th"
                      scope="row"
                      className={classes.tablecell}
                    >
                      {t('summaryTable.table8')}
                    </TableCell>
                    <TableCell
                      component="th"
                      scope="row"
                      className={classNames(classes.tablecell, 'hide-mobile')}
                    ></TableCell>
                    <TableCell
                      component="th"
                      scope="row"
                      className={classNames(classes.tablecell, 'hide-mobile')}
                    >
                      {new Intl.NumberFormat('fi-FI', {
                        style: 'currency',
                        currency: 'EUR'
                      }).format(summaryArray.sumWithTax)}
                    </TableCell>
                    <TableCell
                      component="th"
                      scope="row"
                      className={classes.tablecell}
                    >
                      {new Intl.NumberFormat('fi-FI', {
                        style: 'currency',
                        currency: 'EUR'
                      }).format(summaryArray.gross_salary)}
                    </TableCell>
                    <TableCell
                      component="th"
                      scope="row"
                      className={classNames(classes.tablecell, 'hide-mobile')}
                    >
                      {new Intl.NumberFormat('fi-FI', {
                        style: 'currency',
                        currency: 'EUR'
                      }).format(summaryArray.take_home_pay)}
                    </TableCell>
                    <TableCell
                      component="th"
                      scope="row"
                      className={classNames(classes.tablecell, 'hide-mobile')}
                    >
                      {new Intl.NumberFormat('fi-FI', {
                        style: 'currency',
                        currency: 'EUR'
                      }).format(summaryArray.expenses_cost)}
                    </TableCell>
                    <TableCell
                      component="th"
                      scope="row"
                      className={classNames(classes.tablecell, 'hide-mobile')}
                    >
                      {new Intl.NumberFormat('fi-FI', {
                        style: 'currency',
                        currency: 'EUR'
                      }).format(summaryArray.reimbursment_cost)}
                    </TableCell>
                    <TableCell
                      component="th"
                      scope="row"
                      className={classNames(classes.tablecell, 'hide-mobile')}
                    ></TableCell>
                    <TableCell
                      component="th"
                      scope="row"
                      className={classes.tablecell}
                    ></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      component="th"
                      scope="row"
                      className={classes.tablecell}
                      colSpan={4}
                      style={{ border: 'none' }}
                    >
                      {t('summaryTable.note')}
                    </TableCell>
                  </TableRow>
                </>
              ) : null}
              {pathname === '/dashboard/invoice' &&
              tablePlace !== 'workshift_journal' ? (
                <TableRow>
                  <TableCell
                    component="th"
                    scope="row"
                    className={classes.tablecell}
                    colSpan={4}
                    style={{ border: 'none' }}
                  >
                    {t('invoice.groupInvoice')}
                  </TableCell>
                </TableRow>
              ) : null}
              {pathname === '/dashboard/openforwork/workShifts' ? (
                <TableRow>
                  <TableCell
                    scope="row"
                    className={classes.tablecell}
                    colSpan={6}
                    style={{ border: 'none', fontWeight: '600' }}
                  >
                    These workshift journals can be attached to an invoice. When
                    creating an invoice, you can find a button that shows
                    different available workshift journals that can be attached.
                  </TableCell>
                </TableRow>
              ) : null}
            </TableBody>
          </Table>
          {data.length > 0 ? (
            <ReactPaginate
              previousLabel={<i className="fa fa-chevron-left" />}
              nextLabel={<i className="fa fa-chevron-right" />}
              breakLabel={'...'}
              breakClassName={'break-me'}
              forcePage={page}
              pageCount={_pageCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={handleChangePage}
              containerClassName={'pagination'}
              subContainerClassName={'pages pagination'}
              activeClassName={'active'}
            />
          ) : (
            <div style={{ padding: '40px' }}></div>
          )}
        </div>
      )}
    </Translation>
  )
}

SortableTable.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.array.isRequired,
  /** A function that takes in row data and the row's index and returns a TableRow component*/
  createRowComponent: PropTypes.func.isRequired,
  headerCells: PropTypes.arrayOf(
    PropTypes.shape({
      /** Property name existing in the data that relates to this header*/
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      align: PropTypes.oneOf(['inherit', 'center', 'left', 'right', 'justify']),
      padding: PropTypes.oneOf(['none', 'normal', 'checkbox']),
      isSortable: PropTypes.bool,
      style: PropTypes.object,
      customComparator: PropTypes.func
    })
  ),
  defaultOrder: PropTypes.oneOf(['asc', 'desc']),
  /** id of the headerCell to order by default */
  defaultOrderBy: PropTypes.string,
  rowsPerPage: PropTypes.number,
  enableFilters: PropTypes.bool,
  dense: PropTypes.bool
}

SortableTable.defaultProps = {
  defaultOrderBy: null,
  defaultOrder: 'asc',
  enableFilters: false
}

const styles = (theme) => ({
  root: {
    width: '100%',
    overflowX: 'auto',

    '&::-webkit-scrollbar': {
      width: '12px !important',
      webkitOverflowScrolling: 'auto !important'
    },

    '&::-webkit-scrollbar-track': {
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3) !important',
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important'
    },

    '&::-webkit-scrollbar-thumb': {
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important',
      background: '#41617D !important',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.5) !important'
    },

    '&::-webkit-scrollbar-thumb:window-inactive': {
      background: '#41617D !important'
    }
  },
  table: {
    fontSize: '13px',
    borderTop: '2px solid #999'
  },
  cell: {
    fontSize: '13px',
    fontWeight: 'bold',
    color: '#333'
  },
  dense: {
    padding: '0px 8px'
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1
  },
  expand: {
    transform: 'rotate(0deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: 'rotate(90deg)'
  },
  filters: {
    marginBottom: '24px',
    display: 'flex',
    justifyContent: 'space-between'
  },
  invoiceFilter: {
    marginBottom: 0
  },
  filterButton: {
    paddingTop: theme.spacing(),
    paddingBottom: theme.spacing(),
    width: '100%',
    color: 'gray'
  },
  tablecell: {
    fontWeight: 1000,
    fontSize: '13px',
    maxWidth: '200px',
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    [theme.breakpoints.down('xs')]: {
      padding: '0 10px'
    }
  }
})

export default withStyles(styles)(SortableTable)

function SortableTableHead(props) {
  const { classes, order, orderBy, onRequestSort, headerCells, dense } = props

  const createSortHandler = (property, customComparator) => (event) => {
    onRequestSort(event, property, customComparator)
  }

  return (
    <Translation>
      {(t) => (
        <TableHead>
          <TableRow>
            {headerCells.map((headerCell) => {
              const _classNames = [classes.cell]
              if (headerCell.className) _classNames.push(headerCell.className)
              if (dense) _classNames.push(classes.dense)

              return headerCell.hide ? null : (
                <TableCell
                  className={classNames(_classNames)}
                  key={headerCell.id}
                  style={headerCell.style ?? null}
                  align={headerCell.align ?? 'inherit'}
                  padding={headerCell.padding ?? 'normal'}
                  sortDirection={orderBy === headerCell.id ? order : false}
                >
                  {typeof headerCell.isSortable === 'undefined' ||
                  headerCell.isSortable ? (
                    <TableSortLabel
                      active={orderBy === headerCell.id}
                      direction={orderBy === headerCell.id ? order : 'asc'}
                      onClick={createSortHandler(
                        headerCell.id,
                        headerCell.customComparator
                      )}
                    >
                      {t(headerCell.label)}
                      {orderBy === headerCell.id ? (
                        <span className={classes.visuallyHidden}>
                          {order === 'desc'
                            ? 'sorted descending'
                            : 'sorted ascending'}
                        </span>
                      ) : null}
                    </TableSortLabel>
                  ) : (
                    t(headerCell.label)
                  )}
                </TableCell>
              )
            })}
          </TableRow>
        </TableHead>
      )}
    </Translation>
  )
}

SortableTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string,
  dense: PropTypes.bool
}

function defaultComparator(a, b, orderBy) {
  return descendingComparator(a[orderBy], b[orderBy])
}

export function descendingComparator(a, b) {
  if (isNaN(a) || isNaN(b)) {
    return b.localeCompare(a)
  }
  if (b < a) return -1
  if (b > a) return 1
  return 0
}

function getComparator(order, orderBy, customComparator) {
  if (customComparator) {
    return order === 'desc'
      ? (a, b) => customComparator(a, b)
      : (a, b) => -customComparator(a, b)
  } else
    return order === 'desc'
      ? (a, b) => defaultComparator(a, b, orderBy)
      : (a, b) => -defaultComparator(a, b, orderBy)
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index])
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0])
    if (order !== 0) return order
    return a[1] - b[1]
  })
  return stabilizedThis.map((el) => el[0])
}

const filterData = (data, headerCells, filters) => {
  if (!filters || filters.length === 0) return data
  const filteredData = data.filter((row) => {
    let match = true
    headerCells
      .filter((cell) => cell.filter && typeof cell.filter === 'object')
      .forEach((cell) => {
        if (!filters[cell.id]) return

        //for a custom filter function
        if (cell.filter.function) {
          if (!cell.filter.function(row, filters[cell.id])) {
            match = false
          }
          return
        }

        switch (cell.filter.type) {
          case 'select':
            if (
              cell.filter.locationView === 'userView' &&
              filters[cell.id].toString() === '2'
            ) {
              // KAS-697 Filter Paid and Paid (MP) at invoice table
              if (
                !(
                  row[cell.id].toString() === '2' ||
                  row[cell.id].toString() === '24'
                )
              ) {
                match = false
              }
            } else if (
              !(row[cell.id].toString() === filters[cell.id].toString())
            ) {
              match = false
            }
            return
          case 'string':
            if (
              !row[cell.id]
                .toString()
                .toLowerCase()
                .includes(filters[cell.id].toLowerCase())
            ) {
              match = false
            }
            return
          case 'number':
            if (parseFloat(filters[cell.id]) === isNaN) match = false
            else if (
              !(parseFloat(row[cell.id]) === parseFloat(filters[cell.id]))
            )
              match = false
            return
          case 'date':
            const date = new Date(row[cell.id])
            if (date.getTime() !== filters[cell.id].getTime()) match = false
            return
          case 'checkbox':
            if (!!row[cell.id] !== filters[cell.id]) match = false
            return
          case 'dateFrom':
            const dateFrom = new Date(row[cell.id])
            if (dateFrom.getTime() < filters[cell.id].getTime()) match = false
            return
          case 'dateTo':
            const dateTo = new Date(row[cell.id])
            if (dateTo.getTime() > filters[cell.id].getTime()) match = false
            return
        }
      })
    return match
  })
  return filteredData
}
